import type { CatServiceAPIProductOption } from 'src/services/cat-service-api/types/CatServiceAPIProductOption';

export function imageOptionBounds(productOption: CatServiceAPIProductOption): {
  max: number;
  min: number;
} {
  const minRaw =
    productOption.minImages ?? (productOption as { min_images?: number }).min_images ?? undefined;
  const maxRaw =
    productOption.maxImages ?? (productOption as { max_images?: number }).max_images ?? undefined;
  const min = typeof minRaw === 'number' && !Number.isNaN(minRaw) ? Math.max(0, minRaw) : 0;
  const max =
    typeof maxRaw === 'number' && !Number.isNaN(maxRaw)
      ? Math.max(min, maxRaw)
      : Number.MAX_SAFE_INTEGER;
  return { min, max };
}
